import { registerStoreItem } from 'utils/storeCreator'
import {
  qingsuTeacherList,
  channelInfo,
  channnelAds,
  channelCoupon
} from 'api/qingsu'

let store = registerStoreItem({
  store: {
    namespaced: true,
    state: {
      teacherList: [],
      filterSelect: {
        sort: 'default',
        gender: 0,
        category: 0
      },

      freeQingsuLogo: {},
      freeQingsuBlock: [],
      freeQingsuPoster: null,
      index: {
        out_channel_info: {},
        channel_page_info: {}
      },
      couponInfo: {
        remaining_places: 0,
        coupon: []
      }
    },
    getters: {
      filterData() {
        return [
          {
            type: 'tag',
            child: [
              { key: '0', label: '不限性别' },
              { key: '1', label: '男性' },
              { key: '2', label: '女性' }
            ]
          }
        ]
      }
    },
    mutations: {
      setTeacherList(state, list) {
        state.teacherList = list
      },
      setFilterSelect(state, select) {
        state.filterSelect = select
      },
      replaceBanner(state, lists) {
        state.index.banner = lists
      },

      setFree(state, { key, value }) {
        state[key] = value
      },
      setIndex(state, data) {
        state.index = data
      },
      setCouponInfo(state, data) {
        state.couponInfo = data
      }
    },
    actions: {
      fetchTeacherList({ commit, state }, params) {
        Object.assign(
          {},
          {
            sort: 'default',
            gender: 0,
            category: 0
          },
          params || {}
        )
        return qingsuTeacherList(params).then(res => {
          if (res.code === 0) {
            params.page === 1
              ? commit('setTeacherList', res.data)
              : commit('setTeacherList', [...state.teacherList, ...res.data])

            return res.data
          }
        })
      },
      fetchNewTeacherList({ commit, dispatch }, params) {
        commit('setFilterSelect', params)
        dispatch('fetchTeacherList')
      },
      fetchIndex({ commit }, params) {
        return channelInfo(params).then(res => {
          let { out_channel_info, channel_page_info } = res.data
          if (Array.isArray(out_channel_info)) {
            res.data.out_channel_info = {}
          }
          if (Array.isArray(channel_page_info)) {
            res.data.channel_page_info = {
              channel_id: params.out_channel_id,
              head_image: '',
              id: 54,
              list_title: '全部老师',
              logo:
                'https://ossimg.xinli001.com/2021623/1624451569069ZfXIgeXeurir9nGwXlXvAgOHpQASlKii.jpg',
              order_name: '',
              page_title: '壹心理倾诉',
              brand_name: '壹心理倾诉',
              service_introduction: '',
              share_description: '',
              share_poster: ''
            }
          }
          commit('setIndex', res.data)

          return res
        })
      },
      fetchCoupon({ commit }, params) {
        return channelCoupon(params).then(res => {
          const { code, data } = res
          if (+code === 0 && data) {
            commit('setCouponInfo', data)
          }
        })
      }
    }
  },
  name: 'ads',
  api: channnelAds,
  handle: res => {
    return res.data
  },
  defaultValue: []
})

export default {
  name: 'qingsuchannel',
  store
}
